require('./ChannelSnippet.scss');
require('./_Multichannel/ChannelSnippet_Multichannel.scss');
require('./_Search/ChannelSnippet_Search.scss');

const b = require('app/www/libs/b')('channel-snippet');

const React = require('react');
const PropTypes = require('prop-types');

const Metrika = require('app/www/libs/client/metrika');

const Button_Broadcasting = require('app/www/components/blocks/Button/_Broadcasting/Button_Broadcasting');
const ChannelLogo = require('app/www/components/blocks/ChannelLogo/ChannelLogo');
const Icon = require('app/www/components/blocks/Icon/Icon');
const Link = require('app/www/components/blocks/Link/Link');

class ChannelSnippet extends React.PureComponent {

    render() {
        const {
            id,
            url,
            logo,
            title,
            mods,
            index,
            section,
            onClick,
            logoMods,
            familyId,
            firstEvent,
            showButtons,
            metrikaParams,
            showIndicator,
            isFavorite,
            hasBroadcasting,
            transliteratedFamilyTitle,
        } = this.props;

        const searchParams = {
            id,
            index,
            title,
            section,
            familyId,
            trigger: 'click',
        };

        const linkProps = {
            url,
            onClick: evt => {
                evt.stopPropagation();
                Metrika.trackParams('CHANNEL_TITLE', metrikaParams);
                onClick(searchParams);
            },
        };

        logo.mods = logoMods;

        const buttonBroadcastingProps = {
            channelId: id,
            familyId,
            transliteratedFamilyTitle,
            mods: {
                pin: 'circle',
                theme: 'grey',
                size: 's',
                icon: 'bright',
                'only-icon': true,
            },
            icon: {
                size: 's',
            },
            streamLocation: 'serp',
        };

        const channelLogoProps = {
            className: b('logo'),
            mods: logoMods,
            logo,
        };

        const iconProps = {
            mods: {
                size: 's',
                active: true,
                'favorite-channel': true,
            },
        };

        return (
            <div className={b(mods)}>
                <Link className={b('link')} {...linkProps}>
                    <ChannelLogo {...channelLogoProps} />
                    <h2 className={b('title')}>{title}</h2>
                </Link>
                {showButtons &&
                <div className={b('buttons')}>
                    {hasBroadcasting && (
                        <div className={b('button', {type: 'broadcasting'})}>
                            <Button_Broadcasting {...buttonBroadcastingProps} />
                        </div>
                    )}
                </div>
                }
                {(showIndicator && isFavorite) &&
                <Icon className={b('favorite')} {...iconProps} />
                }
                {firstEvent && (
                    <div className={b('first-event-title')}>
                        {firstEvent.date && `${firstEvent.date} ${firstEvent.startTime}`}
                        {firstEvent.date && firstEvent.title &&
                        <span className={b('bull')}>&bull;</span>
                        }
                        {firstEvent.title}
                    </div>)
                }
            </div>
        );
    }
}

ChannelSnippet.defaultProps = {
    logoMods: {
        size: 'm',
    },
    onClick: () => {},
};

ChannelSnippet.propTypes = {
    id: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
    logo: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    metrikaParams: PropTypes.object,
    firstEventTitle: PropTypes.string,
    showButtons: PropTypes.bool,
    showIndicator: PropTypes.bool,
    hasBroadcasting: PropTypes.bool,
    isFavorite: PropTypes.bool,
    onChangeFavorite: PropTypes.func,
};

module.exports = ChannelSnippet;
